import { render, staticRenderFns } from "./PlayerPendingInfoRewindStoryToQuest.vue?vue&type=template&id=46c97c9e&"
import script from "./PlayerPendingInfoRewindStoryToQuest.vue?vue&type=script&lang=js&"
export * from "./PlayerPendingInfoRewindStoryToQuest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports